// extracted by mini-css-extract-plugin
module.exports = {"submit_button":"style_submit_button__InAnh"};